import requestBus from './requestBus.js'
import '../features/supportPropsAndModelablesV4.js'
import '../features/supportIsolatingV4.js'
import '../features/supportLazyLoadingV4.js'

requestBus.boot()
